import React from 'react';
import { ZdsCheckbox, ZdsFormLabel, ZdsIcon } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
const CheckboxFilter = ({ filter, handleFilterChange, aggregations, activeFilters }) => {
    var _a;
    const filterField = filter.field;
    const buckets = (_a = aggregations[filterField]) === null || _a === void 0 ? void 0 : _a.buckets;
    const isOptionInActiveFilters = (option) => {
        if (activeFilters.userFilters) {
            const activeValue = activeFilters.userFilters[option.filterQuery];
            if (activeValue) {
                return Array.isArray(activeValue)
                    ? activeValue.includes(option.filterValue)
                    : activeValue === option.filterValue;
            }
        }
    };
    const calculateFilterResultCount = (filterOption) => {
        let count = 0;
        if (buckets) {
            if (filterOption.filterQuery === filterField) {
                const bucketItem = buckets.find((x) => x.key == filterOption.filterValue);
                if (bucketItem === null || bucketItem === void 0 ? void 0 : bucketItem.doc_count) {
                    count = bucketItem.doc_count;
                }
            }
            else if (filterOption.filterQuery === filterField + '_min') {
                const items = buckets.filter((obj) => obj.key >= filterOption.filterValue);
                items.forEach((item) => {
                    count += item.doc_count;
                });
            }
            else if (filterOption.filterQuery === filterField + '_max') {
                const items = buckets.filter((obj) => obj.key <= filterOption.filterValue);
                items.forEach((item) => {
                    count += item.doc_count;
                });
            }
            return count;
        }
    };
    return (React.createElement("div", { id: filter.field },
        React.createElement(ZdsFormLabel, null,
            React.createElement(Translation, { item: filter.label })),
        filter.options.map((filterOption) => (React.createElement(ZdsCheckbox, { checked: isOptionInActiveFilters(filterOption), key: filterOption.label, onZdsChange: handleFilterChange, name: filterOption.filterQuery, value: filterOption.filterValue, className: calculateFilterResultCount(filterOption) === 0 && 'zds-muted' },
            React.createElement("div", { className: "zds-flex" },
                filterOption.icon && (React.createElement(ZdsIcon, { library: "fa-regular", name: filterOption.icon, slot: "icon", size: "md", class: "zds-margin-right-2" })),
                React.createElement("span", null,
                    React.createElement(Translation, { item: filterOption.label })),
                calculateFilterResultCount(filterOption) >= 0 && (React.createElement("span", { className: "zds-margin-left-auto" },
                    " ",
                    calculateFilterResultCount(filterOption)))))))));
};
export default CheckboxFilter;
